const PREFIXES = {
  POST_RELATION_DEFAULT: 'post_relation',
  POST_RELATION_CONTENT_ATTACHMENTS: 'post_relation_contentAttachments',
};

export const parsePendingChangeToUserMessage = (key: string): string => {
  if (key.startsWith(PREFIXES.POST_RELATION_CONTENT_ATTACHMENTS)) {
    const match = key.match(/__(.*?)__/);
    key = match ? match[1] : '';
  } else if (key.startsWith(PREFIXES.POST_RELATION_DEFAULT)) {
    key = key.replace(new RegExp(`^${PREFIXES.POST_RELATION_DEFAULT}`), '');
  }

  key = key.replace(/_/g, ' ');

  key = key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim()
    .toLowerCase();

  key = key.replace(/\b\w/g, (char) => char.toUpperCase());

  key = key.replace(/(Id|id)$/, '').trim();

  return key;
};
